export const constructProxyUrl = (url) => {
    const bucketUrl = import.meta.env.VITE_S3_BUCKET_URL
    const s3Url = url?.startsWith('http')
        ? url
        : `${bucketUrl.endsWith('/') ? bucketUrl.slice(0, -1) : bucketUrl}/${url?.startsWith('/') ? url?.slice(1) : url}`

    return s3Url
    // return `${import.meta.env.VITE_BACKEND_URI}/proxy/media?url=${encodeURIComponent(s3Url)}`
}
